

exports.__esModule = true;
exports.NEXT_STATE = exports.AUTH_LINK_HATEOS = undefined;

var _squid = require('squid');

var _logger = require('xo-beaver/dist/logger');

var _checkout = require('xo-models/src/checkout');

var _auth = require('xo-models/src/auth');

var _index = require('xo-models/src/fi/index');

var _venmoModels = require('xo-third-party-components/src/venmo-models');

var _thirdPartyInfo = require('xo-third-party-components/src/thirdParty-info');

var _uiRouter = require('uiRouter');

var _template = require('./template');

var _template2 = _interopRequireDefault(_template);

var _angular = require('angular');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var AUTH_LINK_HATEOS = exports.AUTH_LINK_HATEOS = 'ot_cookie_link';
var NEXT_STATE = exports.NEXT_STATE = 'nextState';

exports['default'] = _squid.$Component.extend('$VenmoAuthEntrypoint', {
    tag: 'venmo-auth-entrypoint',
    template: _template2['default'],

    props: {
        token: {
            type: 'var',
            optional: true
        }
    },

    resolve: {
        venmoParams: function venmoParams() {
            var _ref;

            return _ref = {}, _ref[AUTH_LINK_HATEOS] = _uiRouter.$stateParams[AUTH_LINK_HATEOS], _ref[NEXT_STATE] = _uiRouter.$stateParams[NEXT_STATE], _ref;
        },
        checkoutCart: function checkoutCart() {
            return _checkout.$CheckoutCartModel.instance(this.token).retrieve();
        },
        checkoutPayee: function checkoutPayee() {
            return _checkout.$CheckoutPayeeModel.instance(this.token).retrieve();
        },
        appData: function appData() {
            return _checkout.$CheckoutAppDataModel.instance(this.token).retrieve();
        }
    },

    lifecycle: {
        populate: function populate() {
            var _this = this;

            var venmoParams = this.venmoParams,
                checkoutCart = this.checkoutCart,
                checkoutPayee = this.checkoutPayee;
            var ot_cookie_link = venmoParams.ot_cookie_link,
                nextState = venmoParams.nextState;


            if (ot_cookie_link && nextState) {
                _logger.$logger.info('venmo_ot_cookie_link_landing', { authLink: venmoParams[AUTH_LINK_HATEOS], nextState: venmoParams['nextState'] });
                var hermesLocation = '' + _angular.$location.absUrl().replace(/#.*$/, '');
                var next = nextState.replace(/\./g, '/');

                var params = (0, _angular.$httpParamSerializer)({
                    returnUri: hermesLocation + '#/' + next
                });

                _logger.$logger.info('venmo_stepUp_auth_linkback', hermesLocation + '#/' + next);
                _logger.$logger.info('venmo_stepUp_UL_redirect_to', ot_cookie_link + '&' + params);

                return (0, _thirdPartyInfo.redirect)(ot_cookie_link + '&' + params); // append with the returnUri
            }

            var venmoDcvv = void 0;

            var venmoUserModel = _venmoModels.$VenmoUserModel.instance(this.token);
            var checkoutSessionModel = _checkout.$CheckoutSessionModel.instance(this.token);

            var setVenmoToken = function setVenmoToken() {
                return _thirdPartyInfo.thirdPartyExperience.setAsVenmoExperience(_this.token);
            };

            var createCheckoutSession = function createCheckoutSession() {
                return checkoutSessionModel.action('create', {
                    data: {
                        fraudnet_id: checkoutCart.supplementary && checkoutCart.supplementary.risk_correlation_id,
                        baToken: checkoutCart.billing && checkoutCart.billing.ba_token,
                        user_selected_funding_source: {
                            dcvv: venmoDcvv,
                            product_name: 'VENMO_US_PPMERCHANT_SINGLEUSETOKEN'
                        },
                        is_skip_gfo: true
                    },
                    success: function success(result) {
                        return result;
                    },
                    contingencies: {
                        NEED_SHIPPING_ADDRESS: function NEED_SHIPPING_ADDRESS(msg, contingency) {

                            // In the case the merchant only ships to local country
                            _logger.$logger.info('venmo_shipping_contingency');

                            // If the user hasn't entered a billing address, we'll also take it into consideration.
                            return _index.$BillingAddressesModel.instance().retrieve().then(function (billingAddresses) {

                                self.renderBillingAddCheckbox = !(billingAddresses && billingAddresses.addresses && billingAddresses.addresses['0']);

                                _uiRouter.$state.go('checkout.venmoAuth.infoGather');
                            });
                        },
                        PAYER_AUTHENTICATION_REQUIRED: function PAYER_AUTHENTICATION_REQUIRED(msg, contingency) {
                            _angular.$rootScope.$broadcast('$insufficientPermissionVenmoOT', {
                                oldState: 'checkout.venmoAuth',
                                newState: 'checkout.venmoAuth'
                            });
                        },
                        DEFAULT: function DEFAULT(msg, contingency) {
                            _logger.$logger.info('venmo_unhandled_symphony_contingency', msg);
                        }
                    }
                });
            };

            var refreshAuthState = function refreshAuthState() {
                var authModel = _auth.$AuthModel.instance();
                _squid.$locale.choose(authModel.country, authModel.language, false);

                if (window.xprops && window.xprops.onAuth && authModel && authModel.access_token) {

                    return window.xprops.onAuth({
                        accessToken: authModel.access_token
                    });
                }
                return authModel;
            };

            return venmoUserModel.save({
                data: {
                    intent: checkoutCart.payment_action,
                    merchant_id: checkoutPayee.merchant.id
                },
                success: function success(data) {
                    venmoDcvv = data.dcvv;

                    return createCheckoutSession().then(function (session) {
                        // setting Venmo Experience flag
                        setVenmoToken();
                        refreshAuthState();

                        // if session is populated, we proceed to RYI
                        if (session) {
                            return _uiRouter.$state.go('checkout.review');
                        }

                        // else we'll go back log buyer out and go to Drawer selection
                        return _auth.$AuthModel.instance().logout().then(function () {
                            return _uiRouter.$state.go('checkout.payWithSelection');
                        });
                    });
                },
                contingencies: {
                    SHIPPING_AND_BILLING_REQUIRED: function SHIPPING_AND_BILLING_REQUIRED(msg, contingency) {

                        setVenmoToken();
                        refreshAuthState();
                        _uiRouter.$state.go('checkout.venmoAuth.infoGather');
                    }
                }
            });
        }
    }
});


_squid.$Component;

_squid.$locale;

_logger.$logger;

_checkout.$CheckoutSessionModel;

_checkout.$CheckoutCartModel;

_checkout.$CheckoutAppDataModel;

_checkout.$CheckoutPayeeModel;

_auth.$AuthModel;

_index.$BillingAddressesModel;

_venmoModels.$VenmoUserModel;

_thirdPartyInfo.thirdPartyExperience;

_thirdPartyInfo.redirect;

_uiRouter.$stateParams;

_uiRouter.$state;

_angular.$location;

_angular.$httpParamSerializer;

_angular.$rootScope;


//////////////////
// WEBPACK FOOTER
// ./pages/xo-venmoAuth/directive.js
// module id = ./pages/xo-venmoAuth/directive.js
// module chunks = 0